import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { CommonTypes } from "./types";
import { UIError } from "./errors";

var DineInOrder = /*#__PURE__*/function () {
  function DineInOrder(config, axios) {
    _classCallCheck(this, DineInOrder);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(DineInOrder, [{
    key: "initiateDineInOrder",
    value: function () {
      var _initiateDineInOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(orderId, restaurantNum, visitId, source, kind, jwtToken) {
        var headers, payload;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                payload = {
                  restaurantNum: restaurantNum,
                  visitId: visitId,
                  source: source,
                  kind: kind
                };

                if (orderId) {
                  payload["orderId"] = orderId;
                }

                _context.next = 6;
                return this.axios.get(this.config.postfix.INIT_DINE_IN_ORDER, {
                  params: payload,
                  headers: headers
                }).then(function (response) {
                  return response.data;
                })["catch"](function (error) {
                  throw new UIError(error);
                });

              case 6:
                return _context.abrupt("return", _context.sent);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initiateDineInOrder(_x, _x2, _x3, _x4, _x5, _x6) {
        return _initiateDineInOrder.apply(this, arguments);
      }

      return initiateDineInOrder;
    }()
  }]);

  return DineInOrder;
}();

export { DineInOrder as default };